export default __webpack_public_path__ + "static/media/Pendant of the Legion Commander.876a414e.jpg";